// Rates tab: where the Liabilities box's amount comes from (computePricingLiabilities).
import React from 'react'
import { Popover } from 'antd'
import * as com from "../Common.js"

const dollars = (value) => `$${com.commaizeFloat(value)}`
const plural = (count, word) => `${count} ${word}${count === 1 ? "" : "s"}`
const boxAmount = (shown) => Math.round(Number(shown) || 0)

/** The breakdown table and notes; `shown` is the amount in the box. */
export const LiabilitiesBreakdown = ({ breakdown, shown }) => {
    const notes = []
    if (boxAmount(shown) !== breakdown.total) {
        notes.push(`The box shows ${dollars(boxAmount(shown))}: it was edited here, or the inputs changed after the page loaded.`)
    }
    if (breakdown.excluded.count) {
        notes.push(`Not counted: ${plural(breakdown.excluded.count, "item")} (${dollars(breakdown.excluded.amount)}) unchecked in the debt-to-income calculator.`)
    }
    if (breakdown.lines.some((line) => line.source === "calculator")) {
        notes.push("Calculator: saved in the debt-to-income calculator's estimated monthly payment; the 1003 is not changed. Reset to 1003 values uses the 1003 amounts instead.")
    }
    const unused = breakdown.unusedCalculatorValues
    if (unused.length) {
        const amounts = unused.map((item) => `${item.label.toLowerCase()} (${dollars(item.amount)})`).join(", ")
        notes.push(`Not used: the debt-to-income calculator's ${amounts}. The loan header still uses ${unused.length === 1 ? "it" : "them"}.`)
    }
    notes.push(breakdown.mortgageInsurance1003
        ? `Not included: principal and interest, and mortgage insurance (${dollars(breakdown.mortgageInsurance1003)} on the 1003). Pricing adds each product's own.`
        : "Not included: principal and interest, and mortgage insurance. Pricing adds each product's own.")
    return (
        <div className="liabilities-breakdown">
            <div className="liabilities-breakdown-title">Monthly liabilities sent to pricing</div>
            <table>
                <tbody>
                    {breakdown.lines.map((line) => (
                        <tr key={line.key}>
                            <td>{line.label}{line.count ? ` (${line.count})` : ""}</td>
                            <td className="liabilities-breakdown-amount">{dollars(line.amount)}</td>
                            <td className="liabilities-breakdown-source">{line.source === "calculator" ? "Calculator" : "1003"}</td>
                        </tr>
                    ))}
                    <tr className="liabilities-breakdown-total">
                        <td>Total</td>
                        <td className="liabilities-breakdown-amount">{dollars(breakdown.total)}</td>
                        <td />
                    </tr>
                </tbody>
            </table>
            {notes.map((note) => <p key={note}>{note}</p>)}
        </div>
    )
}

/** Small line under the Liabilities box, with the breakdown on hover. */
export const LiabilitiesHint = ({ breakdown, shown }) => {
    if (!breakdown) return null
    const fromCalculator = breakdown.lines.filter((line) => line.source === "calculator")
    let summary = "From the 1003."
    if (boxAmount(shown) !== breakdown.total) {
        summary = `Calculated: ${dollars(breakdown.total)}.`
    } else if (fromCalculator.length) {
        summary = `Uses the debt-to-income calculator's ${fromCalculator.map((line) => line.label.toLowerCase()).join(", ")}.`
    } else if (breakdown.unusedCalculatorValues.length) {
        summary = "From the 1003, not the debt-to-income calculator."
    }
    return (
        <div className='rate-filter-item-update liabilities-hint'>
            {summary}{" "}
            <Popover content={() => <LiabilitiesBreakdown breakdown={breakdown} shown={shown} />} placement="bottom" trigger="hover">
                <span className='rate-filter-item-update-btn'>What's included</span>
            </Popover>
        </div>
    )
}
